export { default as coachPortraitUrl } from './coach_portrait.jpg';
export { default as threeCoachesPortraitUrl } from './three_coaches_portrait.svg';



// WEBPACK FOOTER //
// ./packages/smart-home-support/pages/profile/resources/index.ts